var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "300.000000pt",
    viewBox: "0 0 300.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\r\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1160 2978 c-163 -83 -104 -328 79 -328 94 0 162 65 169 161 4 49 0 65 -22 103 -47 80 -141 107 -226 64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1690 2978 c-105 -53 -129 -178 -53 -269 103 -121 303 -45 303 116 0 53 -16 88 -57 127 -56 53 -122 62 -193 26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220 2981 c-104 -55 -131 -183 -57 -268 59 -67 147 -83 223 -38 49 29 84 91 84 148 0 129 -140 218 -250 158z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083 2471 c-88 -23 -168 -101 -193 -191 -6 -20 -10 -208 -10 -446 l0 -411 -46 -13 c-93 -26 -193 -108 -248 -202 -52 -90 -58 -138 -54 -401 4 -232 5 -245 30 -307 14 -36 40 -90 58 -119 65 -105 80 -155 80 -273 l0 -108 90 0 90 0 0 96 c0 121 -21 209 -71 304 -105 199 -113 238 -106 495 3 140 7 166 27 208 23 49 95 121 130 130 19 5 20 0 20 -189 l0 -194 90 0 90 0 0 700 0 701 25 24 c33 34 87 34 120 0 l25 -24 0 -484 0 -484 357 -127 c197 -70 370 -137 385 -148 15 -10 39 -39 53 -62 25 -42 25 -45 25 -284 l0 -242 -61 -67 c-89 -98 -102 -128 -107 -250 l-4 -103 86 0 86 0 0 48 c0 95 10 120 71 187 106 118 104 108 104 425 l0 275 -28 60 c-68 145 -107 170 -490 305 l-297 105 0 420 c0 255 -4 434 -10 457 -17 61 -70 129 -125 159 -55 31 -138 44 -192 30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1695 2456 c-40 -17 -82 -67 -96 -115 -33 -112 61 -226 178 -218 131 9 205 148 140 261 -41 72 -145 106 -222 72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2225 2456 c-115 -51 -140 -202 -49 -288 89 -83 232 -53 280 59 61 142 -90 292 -231 229z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685 1921 c-81 -49 -112 -134 -80 -216 54 -142 250 -151 321 -14 21 42 18 117 -9 164 -44 77 -160 110 -232 66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2210 1919 c-82 -47 -113 -156 -68 -234 59 -101 180 -122 269 -48 121 102 44 303 -116 303 -32 0 -63 -8 -85 -21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPin);
export default __webpack_public_path__ + "static/media/ic-pin.9e7a4a04d676f50a3337f87e380a5e10.svg";
export { ForwardRef as ReactComponent };